import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { Home } from './pages/home/home';
import { StoreContext } from './store/store';

export const PATHS = {
  home: '/'
};

export const Router: React.FC = () => {
  const { state } = React.useContext(StoreContext);

  return (
    <Routes>
      <Route path={state.config.initialPath + PATHS.home} element={<Home />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
};
